var saveCartGiftBox = function() {
  var id = parseInt($('#hc-gift-box_cartpage').attr('data-id'));

  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      items: [
        {
          id: id,
          quantity: 1
        }
      ]
    }),
  }).then(res => { window.location = '/cart' });
};

var removeCartGiftBox = function() {
  $('#main-cart-items .hc_gift_box_checkbox-container').removeClass('hc-checked');
  $('#main-cart-items .hc_gift_box_checkbox-container').removeClass('hc-clicked');
  
  var id = parseInt($('#hc-gift-box_cartpage').attr('data-id'));
  var headers = new Headers({ 'Content-Type': 'application/json' });

  var request = {
    method: 'POST',
    headers: headers,
    body: JSON.stringify({updates: {[id]: 0}})
  };
  fetch('/cart/update.js', request)
  .then(function() {
    location.href = '/cart';
  });
};

/*Cart page*/
$(document).on('click', '#main-cart-items .hc_gift_box_checkbox-container:not(.hc-checked) .hc-custom-label_gift_box', function() {
  saveCartGiftBox();
});

$(document).on('click', '#main-cart-items .hc_gift_box_checkbox-container.hc-checked .hc-custom-label_gift_box', function() {
  removeCartGiftBox();
});

$(document).on('click', '#main-cart-items .ajax-cart-item__remove.hc-gift-box', function() {
  removeCartGiftBox();
});

/*Price to show on cart page..*/
window.addEventListener('DOMContentLoaded',function(){
  var hc_handle = $('#hc-gift-box_cartpage').attr('data-product');
  $.ajax({
    type: "GET",
    url: '/products/' + hc_handle + '.js',
    dataType: "json",
    async: false
  }).done(function(product, textStatus, jqXHR) {
    $('#hc-gift-box_cartpage').attr('data-id', product.variants[0].id);
    $('.hc-free.hc-free-giftbox').text(document.querySelector('body').getAttribute("data-currency-symbol")+ (product.price / 100).toFixed(2));
  });
});










/*Drawer*/

var saveCartDrawerGiftBox = function() {
  var id = $('#hc-gift-box').attr('data-id');
  $('.ajax-cart-drawer .hc_gift_box_checkbox-container').addClass('hc-checked');
  $('.ajax-cart-drawer .hc_gift_box_checkbox-container').addClass('hc-clicked');
    
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      items: [
        {
          id: id,
          quantity: 1
        }
      ]
    }),
  })
    .then((res) => res.json())
    .then(() => fetchCart())
    .catch((err) => { /*console.error('Error saving gift box:', err) */ });
};

var removeCartDrawerGiftBox = function() {
  $('.ajax-cart-drawer .hc_gift_box_checkbox-container').removeClass('hc-checked');
  $('.ajax-cart-drawer .hc_gift_box_checkbox-container').removeClass('hc-clicked');

    var id = $('#hc-gift-box').attr('data-id');
    var headers = new Headers({ 'Content-Type': 'application/json' });
    
    var request = {
      method: 'POST',
      headers: headers,
      body: JSON.stringify({updates: {[id]: 0}})
    };
    fetch('/cart/update.js', request)
      .then((res) => res.json())
      .then(() => fetchCart())
      .catch((err) => { /*console.error('Error removing gift box:', err) */ });
};

$(document).on('click', '.ajax-cart-drawer .hc_gift_box_checkbox-container:not(.hc-checked) .hc-custom-label_gift_box', function() {
  saveCartDrawerGiftBox();
});

$(document).on('click', '.ajax-cart-drawer .hc_gift_box_checkbox-container.hc-checked .hc-custom-label_gift_box', function() {
  removeCartDrawerGiftBox();
});

$(document).on('click', '.ajax-cart-drawer .ajax-cart-item__remove.hc-gift-box', function() {
  removeCartDrawerGiftBox();
});
